import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useDeleteInternalChannel } from "@/components/pages/chats/hooks/useChannel";
import { DeleteChannelConfirmModal } from "./DeleteChannelConfirmModal";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

interface DeleteChannelButtonProps {
  channelId: string;
  channelName?: string;
  onSuccess?: () => void;
}

export const DeleteChannelButton: React.FC<DeleteChannelButtonProps> = ({
  channelId,
  channelName,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { mutate: deleteChannel, isPending } = useDeleteInternalChannel();
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleDelete = () => {
    deleteChannel(channelId, {
      onSuccess: () => {
        toast.success(t("chats.successDelete"));
        setIsModalOpen(false);
        onSuccess?.();
      },
      onError: (error) => {
        toast.error(t("chats.errorDelete"));
        console.error("Failed to delete channel:", error);
      },
    });
  };

  return (
    <>
      <Button
        type="button"
        variant="new_ghost"
        size="icon"
        onClick={handleOpenModal}
        title={t("chats.delete")}
        aria-label={t("chats.delete")}
        className="text-custom-destructive-dark hover:text-custom-destructive-dark rounded-lg"
      >
        <Trash2 />
      </Button>
      <DeleteChannelConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleDelete}
        isLoading={isPending}
        channelName={channelName}
      />
    </>
  );
};
